import { NextSeo, WebPageJsonLd } from "next-seo";
import { Navbar } from "~/components/Navbar/component";
import { PageWrapper, SidebarLayout } from "~/components/SidebarLayout";
import { SOCIAL_OG_IMAGE_URL } from "~/consts";
import { PageTrack } from "~/modules/analytics/components/PageTrack";
import { addBaseUrl } from "~/modules/app/seo/addBaseUrl";
import { BreadcrumbSEO } from "~/modules/app/seo/BreadcrumbSEO";
import { PrivacyPage } from "~/modules/legal/pages/privacy";
import { UserFetcher } from "~/modules/user/components/UserFetcher";
import { Routes } from "~/routes";

// // // //

const SEO_TITLE = "Privacy Policy";
const SEO_DESCRIPTION =
    "Read the RWA.xyz Privacy Policy to learn how Castle Labs, Inc. collects, uses, and protects your personal information when you use RWA.xyz.";

// // // //

export default function Privacy() {
    return (
        <PageTrack>
            <NextSeo
                title={SEO_TITLE}
                description={SEO_DESCRIPTION}
                canonical={addBaseUrl(Routes.privacyPolicy)}
                openGraph={{
                    type: "website",
                    url: addBaseUrl(Routes.privacyPolicy),
                    title: SEO_TITLE,
                    site_name: "RWA.xyz",
                    description: SEO_DESCRIPTION,
                    images: [
                        {
                            url: SOCIAL_OG_IMAGE_URL,
                            width: 4000,
                            height: 2300,
                            alt: "rwa.xyz",
                        },
                    ],
                }}
                additionalMetaTags={[
                    {
                        name: "keywords",
                        content:
                            "RWA.xyz privacy policy, data privacy, personal information, cookies, data protection",
                    },
                ]}
            />
            <WebPageJsonLd
                id={addBaseUrl(Routes.privacyPolicy)}
                description={SEO_DESCRIPTION}
                reviewedBy={{
                    type: "Organization",
                    name: "RWA.xyz",
                }}
            />
            <BreadcrumbSEO
                items={[
                    {
                        name: SEO_TITLE,
                        href: Routes.privacyPolicy,
                    },
                ]}
            />
            <UserFetcher>{({ user }) => <Navbar user={user} />}</UserFetcher>
            <SidebarLayout pathname={Routes.privacyPolicy} showFooter>
                <PageWrapper>
                    <PrivacyPage />
                </PageWrapper>
            </SidebarLayout>
        </PageTrack>
    );
}
